import {useCallback, useEffect} from 'react';
import {useHistory} from 'react-router-dom';
import RootStore from '../Core/mobx/RootStore';
import {ContactFormStore} from '../Agent/ContactForm/ContactFormStore/ContactFormStore';
import {ParameterStore} from '../Core/mobx/ParameterStore/ParameterStore';

type Props = {
    children: JSX.Element;
};

const RouterInterceptor = ({children}: Props): JSX.Element => {
    const history = useHistory();

    const onRouteChange = useCallback(
        (location, action) => {
            if (location.pathname === '/' && action === 'PUSH') {
                RootStore.agentPortalStore.parameterStore = new ParameterStore();
                RootStore.agentPortalStore.contactsFormStore = new ContactFormStore(RootStore.agentPortalStore);
            }
        },
        [history],
    );

    useEffect(() => {
        if (!history) {
            return undefined;
        }
        const unlisten = history.listen(onRouteChange);
        return () => {
            unlisten();
        };
    }, [history]);

    return children;
};

export default RouterInterceptor;
